function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * @module wdh
 */
var WDHVariation = /*#__PURE__*/function () {
  /**
     * Base class for all WDH component variations
     *
     * @param {string} className - Class name of the variation. It will trigger the variation behavior
     */
  function WDHVariation(className) {
    _classCallCheck(this, WDHVariation);

    this.className = className;
  }

  _createClass(WDHVariation, [{
    key: "init",
    value: function init(component) {
      /* eslint-disable-line */
    }
  }, {
    key: "resize",
    value: function resize(component) {
      /* eslint-disable-line */
    }
  }, {
    key: "scroll",
    value: function scroll(component) {
      /* eslint-disable-line */
    }
  }]);

  return WDHVariation;
}();

export default WDHVariation;